import { useEffect } from "react";
import { useLocation, useOutlet } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

const EASE = [0.76, 0, 0.24, 1];

const page = {
  initial: { opacity: 0, y: 24 },
  enter: { opacity: 1, y: 0, transition: { duration: 0.7, delay: 0.35, ease: [0.22, 1, 0.36, 1] } },
  exit: { opacity: 0, y: -16, transition: { duration: 0.35, ease: "easeIn" } },
};

const curtain = {
  initial: { scaleY: 1, transformOrigin: "top" },
  enter: { scaleY: 0, transformOrigin: "top", transition: { duration: 0.7, ease: EASE, delay: 0.05 } },
  exit: { scaleY: 1, transformOrigin: "bottom", transition: { duration: 0.55, ease: EASE } },
};

export default function PageTransition() {
  const outlet = useOutlet();
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) return;
    const t = setTimeout(() => {
      const el = document.getElementById(hash.slice(1));
      if (!el) return;
      if (window.__lenis) window.__lenis.scrollTo(el, { offset: -90 });
      else el.scrollIntoView({ behavior: "smooth" });
    }, 1300);
    return () => clearTimeout(t);
  }, [pathname, hash]);

  return (
    <AnimatePresence
      mode="wait"
      initial={false}
      onExitComplete={() => {
        if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
        else window.scrollTo(0, 0);
      }}
    >
      <motion.div key={pathname} initial="initial" animate="enter" exit="exit" className="relative">
        <motion.div variants={page}>{outlet}</motion.div>
        <motion.div
          variants={curtain}
          className="pointer-events-none fixed inset-0 z-[150] flex items-center justify-center bg-pine"
          aria-hidden
        >
          <img src="/brand/leaf.png" alt="" className="h-16 w-16 object-contain opacity-80" />
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}
